import React, { useState, useEffect, useRef } from 'react';
import { Modal, Swiper } from 'antd-mobile';
import { NavLink } from '../../../lib/Navigation';
import URI from 'urijs';
import './css/GrowthLevel.css';
import { url } from '../../../env';
import general from '../../../general';

export default props => {
  // 定义状态变量
  const [actualTotalLevels, setActualTotalLevels] = useState(0);
  const [loading, setLoading] = useState(true);
  const [currentActiveIndex, setCurrentActiveIndex] = useState(1);
  const [data, setData] = useState({});
  const [list, setList] = useState([]);
  const [init, setInit] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false); // 指示轮播图是否正在动画

  // 模拟网络请求数据
  const getData = () => {
    general.axios.post('/honorHome')
      .then(res => {
        const { status, data: datas } = res.data;
        if (status.succeed) {
          if (init){
            setList(datas.items);
          }else {
            setInit(true)
            setData(datas);
            setList(datas.items);
            setActualTotalLevels(datas.items.length);
            const initialLevel = parseInt(datas.level) === 0 ? 1 : parseInt(datas.level);
            setCurrentActiveIndex(initialLevel);
            setLoading(false);
          }
        } else {
          Dialog.error(status.error_desc);
        }
      })
      .catch(err => {
        Dialog.error(err.message);
      });
  };

  useEffect(() => {
    if (props.active) {
      getData();
    }
  }, [props.active]);

  // 侧边栏导航链接
  useEffect(() => {
    if (props.active) {
      props.setOperate(<NavLink
        to={(() => {
          const string = url + '/honorLevelRule';
          let urlstring = URI(string).addQuery('from', 'react').toString();
          return urlstring;
        })()}
        user={false} iframe={{ title: '荣耀会员等级规则' }} className="item" >
        等级规则
      </NavLink>);
    }
  }, [props.active]);

  // --- 静态常量和计算（与之前保持一致） ---
  const ARC_HORIZONTAL_RADIUS = window.innerWidth > 720 ? 720 : window.innerWidth;
  const ELLIPSE_FLATTEN_FACTOR = 0.5;
  const VIEWPORT_HEIGHT = 80;
  const VIEWPORT_WIDTH = ARC_HORIZONTAL_RADIUS * 2;
  const ELLIPSE_UPWARD_OFFSET = 20;
  const GOLD_COLOR = '#FFD700';
  const COLOR_5_7_OCLOCK = '#D5C6AB';
  const COLOR_4_8_OCLOCK = '#787160';
  const BORDER_ARC_STROKE_WIDTH = 5;
  const DOT_COUNT = 5;
  const DOT_RADIUS = 4;
  const DOT_OFFSET_FROM_ARC = 5;
  const LABEL_TEXT_VERTICAL_OFFSET = 0;
  const SVIP_CIRCLE_VERTICAL_OFFSET = -15;
  const CONNECTING_ARC_VERTICAL_OFFSET = -25;
  const ARC_VERTICAL_RADIUS = ARC_HORIZONTAL_RADIUS * ELLIPSE_FLATTEN_FACTOR;
  const ellipseCenterTop = VIEWPORT_HEIGHT - ARC_VERTICAL_RADIUS - ELLIPSE_UPWARD_OFFSET;
  const svgContainerWidth = ARC_HORIZONTAL_RADIUS * 2;
  const svgContainerHeight = ARC_VERTICAL_RADIUS * 2;
  const backgroundArcPathD = `M 0 ${ARC_VERTICAL_RADIUS} A ${ARC_HORIZONTAL_RADIUS} ${ARC_VERTICAL_RADIUS} 0 0 1 ${ARC_HORIZONTAL_RADIUS * 2} ${ARC_VERTICAL_RADIUS}`;
  const adjustedBackgroundSvgTop = VIEWPORT_HEIGHT - (ARC_VERTICAL_RADIUS * 2) - ELLIPSE_UPWARD_OFFSET;
  const targetDegreeForCenter = 180;
  const pointLeftmostAngle = 205;
  const pointRightmostAngle = 160;
  const pointDegreesPerStep = (pointLeftmostAngle - pointRightmostAngle) / 4;
  const arcLeftmostAngle = 210;
  const arcRightmostAngle = 150;
  const degreesPerLevelStep = pointDegreesPerStep;
  const totalLevelsWithPlaceholders = actualTotalLevels > 0 ? actualTotalLevels + 2 : 2;

  const getSvgPointFromAngle = (angleDegrees) => {
    const angleRad = angleDegrees * Math.PI / 180;
    const xOnEllipse = ARC_HORIZONTAL_RADIUS * Math.sin(angleRad);
    const yOnEllipse = ARC_VERTICAL_RADIUS * -Math.cos(angleRad);
    const svgCx = xOnEllipse + ARC_HORIZONTAL_RADIUS;
    const svgCy = yOnEllipse + ARC_VERTICAL_RADIUS;
    return { x: svgCx, y: svgCy };
  };

  const getLabelColor = (distanceFromCenterIndex, isCurrentActive) => {
    if (isCurrentActive) return GOLD_COLOR;
    const absDistance = Math.abs(distanceFromCenterIndex);
    if (absDistance === 1) return COLOR_5_7_OCLOCK;
    if (absDistance === 2) return COLOR_4_8_OCLOCK;
    return 'transparent';
  };

  let connectingCirclesArcPathD = "";

  if (!loading && actualTotalLevels > 0) {
    const levelsToRenderArcAndCircles = [];
    for (let d = -2; d <= 2; d++) {
      levelsToRenderArcAndCircles.push(currentActiveIndex + d);
    }
    levelsToRenderArcAndCircles.sort((a, b) => a - b);

    if (levelsToRenderArcAndCircles.length === 5) {
      const arcStartPoint = getSvgPointFromAngle(arcLeftmostAngle);
      const arcEndPoint = getSvgPointFromAngle(arcRightmostAngle);
      const arcStartSvgX = arcStartPoint.x;
      const arcStartSvgY = arcStartPoint.y + CONNECTING_ARC_VERTICAL_OFFSET;
      const arcEndSvgX = arcEndPoint.x;
      const arcEndSvgY = arcEndPoint.y + CONNECTING_ARC_VERTICAL_OFFSET;
      const totalAngleDegrees = Math.abs(arcLeftmostAngle - arcRightmostAngle);
      const largeArcFlag = totalAngleDegrees > 180 ? 1 : 0;
      const sweepFlag = 0;
      connectingCirclesArcPathD = `M ${arcStartSvgX} ${arcStartSvgY} ` +
        `A ${ARC_HORIZONTAL_RADIUS} ${ARC_VERTICAL_RADIUS} 0 ${largeArcFlag} ${sweepFlag} ` +
        `${arcEndSvgX} ${arcEndSvgY}`;
    } else {
      connectingCirclesArcPathD = "";
    }
  }

  return (
    <>
      {!loading && (
        <div className="svip-page-container">
          <div className="growth-display">
            <img src={data.avatar} alt="SVIP Logo" className="growth-svip-logo" />
            <div className="growth-username">{data.username}</div>
            <div className="growth-points-text">
              <span>荣耀值：{data.honorNum}</span>&nbsp;&nbsp;&nbsp;
              <NavLink style={{ fontSize: '13px', color: '#999' }} to='/growthrecord'>成长记录{'>'}</NavLink>
            </div>

            <div
              className="svip-arc-viewport"
              style={{ width: `${VIEWPORT_WIDTH}px`, height: `${VIEWPORT_HEIGHT}px` }}
            >
              <svg
                className="arc-background-and-dots-svg"
                width={svgContainerWidth}
                height={svgContainerHeight}
                viewBox={`0 0 ${svgContainerWidth} ${svgContainerHeight}`}
                style={{
                  position: 'absolute',
                  top: `${adjustedBackgroundSvgTop}px`,
                  left: '50%',
                  transform: `translateX(-50%)`,
                  overflow: 'visible',
                  zIndex: 1,
                }}
              >
                <defs>
                  <linearGradient id="arcBorderGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stopColor={'#6E6757'} />
                    <stop offset="50%" stopColor={GOLD_COLOR} />
                    <stop offset="100%" stopColor={'#6E6757'} />
                  </linearGradient>
                  <radialGradient id="centerDotGlow" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                    <stop offset="0%" stopColor={GOLD_COLOR} stopOpacity="1" />
                    <stop offset="100%" stopColor={GOLD_COLOR} stopOpacity="0" />
                  </radialGradient>
                  <linearGradient id="connectingArcGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stopColor={'#DCDCDC'} stopOpacity="0.3" />
                    <stop offset="50%" stopColor={GOLD_COLOR} stopOpacity="1" />
                    <stop offset="100%" stopColor={'#DCDCDC'} stopOpacity="0.3" />
                  </linearGradient>
                </defs>

                <path
                  d={backgroundArcPathD}
                  stroke="url(#arcBorderGradient)"
                  strokeWidth={BORDER_ARC_STROKE_WIDTH}
                  fill="none"
                />
                {Array.from({ length: DOT_COUNT }, (_, i) => {
                  const centerDotIndex = (DOT_COUNT - 1) / 2;
                  const isCenterDot = i === centerDotIndex;
                  const dotX = (i / (DOT_COUNT - 1)) * svgContainerWidth;
                  const dotY = ARC_VERTICAL_RADIUS + DOT_OFFSET_FROM_ARC;

                  let customDotColor;
                  if (isCenterDot) {
                    customDotColor = null;
                  } else if (i === 1 || i === 3) {
                    customDotColor = '#D5C6AB';
                  } else {
                    customDotColor = '#78715F';
                  }

                  return (
                    <circle
                      key={i}
                      cx={dotX}
                      cy={dotY}
                      r={DOT_RADIUS}
                      fill={isCenterDot ? "url(#centerDotGlow)" : customDotColor}
                      stroke={isCenterDot ? GOLD_COLOR : 'none'}
                      strokeWidth={isCenterDot ? 1 : 0}
                      className={isCenterDot ? 'background-dot-glow' : ''}
                    />
                  );
                })}

                {connectingCirclesArcPathD && (
                  <path
                    d={connectingCirclesArcPathD}
                    stroke="url(#connectingArcGradient)"
                    strokeWidth="2.5"
                    fill="none"
                    className="connecting-circles-arc"
                  />
                )}

              </svg>

              <div
                className="svip-arc-circle"
                style={{
                  top: `${ellipseCenterTop}px`
                }}
              >
                {totalLevelsWithPlaceholders > 0 && Array.from({ length: totalLevelsWithPlaceholders }, (_, i) => {
                  const paramAngle = targetDegreeForCenter + (currentActiveIndex - i) * degreesPerLevelStep;
                  const baseSvgPoint = getSvgPointFromAngle(paramAngle);

                  const yRelativeToEllipseCenter = baseSvgPoint.y - ARC_VERTICAL_RADIUS;

                  const isThisActiveLabel = (i === currentActiveIndex);
                  const distance = i - currentActiveIndex;
                  const labelColor = getLabelColor(distance, isThisActiveLabel);
                  let displayOpacity = 1;

                  const isActualLevelIndexInArc = i >= 1 && i <= actualTotalLevels;

                  const absDistance = Math.abs(distance);
                  if (absDistance > 2) {
                    displayOpacity = 0;
                  }

                  if (!isActualLevelIndexInArc) {
                    if (
                      (i === 0 && (currentActiveIndex !== 1 || absDistance > 2)) ||
                      (i === actualTotalLevels + 1 && (currentActiveIndex !== actualTotalLevels || absDistance > 2))
                    ) {
                      displayOpacity = 0;
                    }
                  }

                  return (
                    <div
                      key={i}
                      className={`svip-level-item ${!isActualLevelIndexInArc ? 'placeholder-item' : ''}`}
                      style={{
                        left: `calc(50% + ${baseSvgPoint.x - ARC_HORIZONTAL_RADIUS}px)`,
                        top: `calc(50% + ${yRelativeToEllipseCenter + LABEL_TEXT_VERTICAL_OFFSET}px)`,
                        transform: `translate(-50%, -50%)`,
                        color: labelColor,
                        opacity: displayOpacity,
                        pointerEvents: displayOpacity === 0 ? 'none' : 'auto',
                        transition: 'left 0.5s ease-in-out, top 0.5s ease-in-out, opacity 0.3s ease-out',
                      }}
                    >
                      {isActualLevelIndexInArc && (
                        <div
                          className={`svip-level-circle ${isThisActiveLabel ? 'svip-level-circle-active' : ''}`}
                          style={{
                            backgroundColor: isActualLevelIndexInArc
                              ? (isThisActiveLabel ? '#f2eac3' : labelColor)
                              : 'transparent',
                            top: `${SVIP_CIRCLE_VERTICAL_OFFSET}px`,
                          }}
                        ></div>
                      )}
                      {isActualLevelIndexInArc ? (
                        <span style={{
                          transform:
                            distance === -2 ? 'rotate(15deg)' :
                              distance === -1 ? 'rotate(7deg)' :
                                distance === 1 ? 'rotate(-7deg)' :
                                  distance === 2 ? 'rotate(-15deg)' :
                                    'rotate(0deg)',
                          display: 'inline-block',
                          whiteSpace: 'nowrap',
                          transformOrigin: 'center',
                          transition: 'transform 0.5s ease-in-out'
                        }}>
                          {`V${i}`}
                        </span>
                      ) : (
                        <span style={{ width: '40px', visibility: 'hidden' }}>{i === 0 ? 'V0' : `V${actualTotalLevels + 1}`}</span>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="carousel-wrapper">
            <div className="carousel-card-container">
              {list.length > 0 && (
                <Swiper
                  className="carousel-swiper"
                  slideSize={90}
                  trackOffset={5}
                  stuckAtBoundary={false}
                  // 使用 defaultIndex，因为它只在组件首次挂载时生效
                  defaultIndex={currentActiveIndex - 1}
                  allowTouchMove={!isAnimating}
                  onIndexChange={swiperIndex => {
                    setIsAnimating(true);
                    setCurrentActiveIndex(swiperIndex + 1);

                    setTimeout(() => {
                      setIsAnimating(false);
                    }, 500);
                  }}
                  indicator={() => null}
                >
                  {list.map((item, index) => (
                    <Swiper.Item key={index}>
                      <div className="carousel-card" style={{
                        backgroundImage: `url(${item.bgimg})`,
                        backgroundSize: '100% 100%',
                        backgroundRepeat: 'no-repeat'
                      }}>
                        <img src={item.icon2} alt="" className="icon2" />
                        <div className="carousel-level">
                          <img className='icon1' src={item.icon1} alt="" />
                          <div className='current-label' style={{ color: item.textColor }}>需要荣誉值{item.need}</div>
                        </div>
                        <div className="carousel-detail">
                          <div className='current-label' style={{ color: item.textColor }}>{item.diff}</div>
                          {parseInt(item.isMeet) == 0 && <div className="current-activate-btn" onClick={() => {
                            Modal.show({
                              bodyClassName: 'index-trade-alert',
                              title: <div style={{ fontSize: '17px', fontWeight: '500', color: '#282828' }}>升级小技巧</div>,
                              content: <div style={{ fontSize: '13px', color: '#282828', textAlign: 'center' }}>游戏实付：在游戏内每现金充值一元，可增加一点荣耀值</div>,
                              actions: [
                                {
                                  key: 'know',
                                  text: '玩游戏',
                                  className: 'done',
                                  onClick: () => {
                                    Modal.clear();
                                    setTimeout(() => {
                                      general.history.push('/user/game')
                                    }, 300);
                                  }
                                },
                                {
                                  key: "cancel",
                                  text: "取消",
                                  className: 'cancel',
                                  onClick: () => {
                                    Modal.clear();
                                  }
                                },
                              ]
                            })
                          }}>升级攻略</div>}
                        </div>
                      </div>
                    </Swiper.Item>
                  ))}
                </Swiper>
              )}
            </div>
          </div>

          <div className="carousel-privilege">
            <div className="carousel-privilege-container" style={{
              backgroundImage: 'url(resources/modifyprice/bg.png)',
              backgroundRepeat: 'no-repeat',
              backgroundSize: '100% 100%',
            }}>
              <div className="carousel-privilege-container-header">
                荣耀V{currentActiveIndex}专享特权
                <img className='star' src="resources/modifyprice/star.png" alt="" />
              </div>
              <div className="carousel-privilege-container-contents">
                {list[currentActiveIndex - 1]?.benefit.map((item, index) => {
                  return (
                    <NavLink to={'/growthprivileges?index=' + index + "&level=" + currentActiveIndex} className="carousel-privilege-item">
                      <div className="carousel-privilege-item-icon">
                        <img src={item.icon} alt='' />
                        {item.showTips == 1 && <img className='receive' src='resources/modifyprice/receive.png' alt='' />}
                      </div>
                      <div className={item.active === 1 ? "carousel-privilege-item-title" : "carousel-privilege-item-title-disable"}>
                        {item.desc}
                      </div>
                      <div className={item.active === 1 ? "carousel-privilege-item-description" : "carousel-privilege-item-description-disable"}>
                        {item.tips}
                      </div>
                    </NavLink>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};